import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Third party

import { Ng2TableModule } from 'ng2-table/ng2-table';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { NgSelectModule } from '@ng-select/ng-select';
import {FileUploadModule} from 'primeng/fileupload';

// Local
import { IframeComponent } from './iframe/iframe.component';
import { SharedModule } from '@app/shared/shared.module';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PaginationModule,
    Ng2TableModule,
    NgSelectModule,
    FileUploadModule,
    SharedModule
  ],
  declarations: [
    IframeComponent
  ],
  exports:[
    IframeComponent
  ]

})
export class UtilidadesExternasModule { }



// WEBPACK FOOTER //
// ./src/app/utilidades-externas/utilidades-externas.module.ts